import React, { useState } from 'react'
import EditOrgWithDaData from '../Modals/EditOrgWithDaData'
import DaDataModal from '../Modals/DaDataModal'
import OrgPage from '../OrgPage'
import PropTypes from 'prop-types'

OrganizationListPageTemplate.propTypes = {
  getOrgListAPI: PropTypes.string.isRequired,
  breadCrumbsItems: PropTypes.array.isRequired,
  tableModel: PropTypes.object,
  addOrgAPI: PropTypes.string,
  roleIs: PropTypes.number,
  addOrgIsShow: PropTypes.bool,
  addOrgConf: PropTypes.shape(
    {
      org: PropTypes.bool,
      medCenter: PropTypes.bool
    })
}

function OrganizationListPageTemplate(props) {
  const baseURL = process.env.REACT_APP_BASE_URL
  const [modal, showModal] = useState()
  const [editModal, showEditModal] = useState()
  const [modalId, setModalId] = useState()
  const [refresh, setRefresh] = useState(false)

  const editOrg = (data) => {
    setModalId(data)
    showEditModal(true)
  }

  const closeHandler = () => {
    showModal(false)
    showEditModal(false)
    setRefresh(!refresh)
  }
  const tableModel = { ...props.tableModel }
  tableModel.haveToShow[0].typeData.onClick = editOrg

  return (
    <>
      {editModal
        ? <EditOrgWithDaData id={modalId}
                             closeHandler={closeHandler}
                             url={''} /> : ''}

      {modal
        ? <DaDataModal closeHandler={closeHandler} role={props.roleIs}
                       url={props.addOrgAPI} />
        : ''}

      <OrgPage
        refresh={refresh}
        firstRow={tableModel.firstRow}
        haveToShow={tableModel.haveToShow}
        url={`${baseURL}${props.getOrgListAPI}`}

        breadCrumbsItems={props.breadCrumbsItems}

        addOrg={{
          org: props.addOrgIsShow,
          onClick() {
            showModal(!modal)
          }
        }}

        filterBarButtons={{
          downloadTemplate: {
            show: false,
            url: '/'
          }
        }}
        filterFieldsConf={props.filterFieldsConf}
      />
    </>
  )
}

export default OrganizationListPageTemplate


OrganizationListPageTemplate.defaultProps = {
  addOrgIsShow: true,
  filterFieldsConf: {
    name: true,
    inn: true,
    date: true,
    period: true
  },
  tableModel: {

    firstRow:
      [
        { title: 'Название', id: 'name' },
        { title: 'Календарь', id: '' },
        { title: 'Количество людей', id: '' },
        { title: 'Вызов', id: '' }
      ],
    haveToShow:
      [
        { id: 'org_name', type: 'linkCell2', idArr: ['id'], typeData: { onClick: function() {} } },
        { id: 'id', type: 'toCalendar', idArr: ['org_name'] },
        { id: 'patients_count' },
        { id: 'invite_count' }
        // {id: 'payed', idArr: ['organizationId'], type: 'checkboxCell'}
      ]
  }
}